import React, { useState, useRef, useEffect } from "react";
import EntityInfo from "./EntityInfo";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import backgroundImage from "~/images/modal-background-image.png";
import { Close } from "@mui/icons-material";
import { createPortal } from "react-dom";
import CheckBox from "../Checkbox";
import useOutsideClick from "../Hooks/useOutsideClick";
import MixpanelService from "../utils/MixpanelService";

const CustomTextField = withStyles({
  root: {
    backgroundColor: "transparent",
    borderRadius: 8,
    "& label.Mui-focused": {
      color: "#3D71FF",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: "#ffffff",
      "& fieldset": {
        borderColor: "#DEE7EE",
      },
      "&:hover fieldset": {
        borderColor: "#DEE7EE",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#3D71FF",
      },
    },
  },
})(TextField);

const AddTpaModal = ({ entity, submitPermission, closeModal }) => {
  const [checked, setChecked] = useState({
    eligibility: null,
    submissions: null,
  });
  const [accessKey, setAccessKey] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const modalRef = useRef();

  useOutsideClick(modalRef, closeModal);

  useEffect(() => {
      // on mount
      MixpanelService.track('esp_tpa_modal_loaded');
  }, [])

  const permissions = [
    {
      title: "Read Eligibility",
      description: "Allow TPA to read eligibility for your Covered Entity",
      value: "eligibility",
    },
    {
      title: "Read and Write Submissions",
      description: "Allow TPA to submit claims on behalf of your Covered Entity",
      value: "submissions",
    },
  ];

  const roles = {
    eligibility: "read_only",
    submissions: "read_write",
  };

  function noPermissionsChecked() {
    return Object.keys(checked).every((permission) => !checked[permission]);
  }

  function tokenInputEmpty() {
    return !accessKey.length;
  }

  function submitDisabled() {
    return noPermissionsChecked() || tokenInputEmpty();
  }

  function handleSubmit() {
    submitPermission(entity.id_340b, accessKey, checked.eligibility, checked.submissions, submitting, setSubmitting, true);
    closeModal();
  }

  function handleCheck(resource) {
    if (checked[resource]) {
      setChecked({ ...checked, [resource]: null });
      return;
    }

    setChecked({ ...checked, [resource]: roles[resource] });
  }

  function renderPermissions() {
    return permissions.map((permission) => {
      return (
        <div key={permission.value} className="tpa-modal__check-item" onClick={() => handleCheck(permission.value)}>
          <CheckBox isSelected={checked[permission.value]} />
          <div className="flex flex-column gap--4">
            <div className="t--500">{permission.title}</div>
            <div>{permission.description}</div>
          </div>
        </div>
      );
    });
  }

  return createPortal(
    <div className="tpa-modal__background">
      <div className="tpa-modal__container" ref={modalRef}>
        <div className="tpa-modal__header">
          <div className="tpa-modal__header__img">
            <img src={backgroundImage} width={145} />
          </div>
          <div className="button button--sq-md button--transparent" onClick={closeModal}>
            <Close />
          </div>
        </div>
        <div className="tpa-modal__body">
          <div className="t--xl t--500">Add TPA</div>
          <div className="bg br--8 pa--16">
            <EntityInfo id_340b={entity.id_340b} name={entity.entity_name} />
          </div>
          <div>
            <div>
              Your TPA will need to provide you their 340B ESP Access Token. Add an Access Token below to grant access.
            </div>
            <CustomTextField
              label="Access Token"
              margin="normal"
              variant="outlined"
              id="access_key"
              name="access_key"
              onChange={(e) => setAccessKey(e.target.value)}
              fullWidth
              required
            />
          </div>
          <div className="flex flex-column gap--16">
            <div>Assign permissions for this TPA.</div>
            {renderPermissions()}
          </div>
          <div className="flex justify-content-end gap--16">
            <button className="button button--white t--500" onClick={closeModal}>
              Cancel
            </button>
            <button className="button button--blue t--500" disabled={submitDisabled()} onClick={handleSubmit}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AddTpaModal;
